const Staff = {

    // FIELDS
    "name": "Name",
    "staff_id": "Staff ID",
    "mobile": "Mobile",
    "email": "Email",
    "password": "Password",
    "confirm_password": "Confirm Password",
    "department": "Department",
    "designation": "Designation",
    "role": "Role",
    "profile_photo": "Profile Photo",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "staff": "Staff",

    // ERROR
    "error_name": "Enter Name",
    "error_staff_id": "Enter Staff ID",
    "error_mobile": "Enter Mobile",
    "error_email": "Enter Email",
    "error_email_invalid": "Enter Valid Email",
    "error_password": "Enter Password",
    "error_password_min": "Password must be at least 6 characters",
    "error_confirm_password": "Enter Confirm Password",
    "error_confirm_password_match": "Passwords must match",
    "error_department": "Select Department",
    "error_designation": "Select Designation",
    "error_role": "Select Role",
    "error_profile_photo_type": "Profile photo must be JPG, JPEG, or PNG format",

    // TABLE HEADER
    "table_name": "NAME",
    "table_staff_id": "STAFF ID",
    "table_mobile": "MOBILE",
    "table_email": "EMAIL",
    "table_department": "DEPARTMENT",
    "table_designation": "DESIGNATION",
    "table_role": "ROLE",
    "table_status": "STATUS",

}

export default Staff;